<template>
    <div style="margin-bottom:15px">
        <header style="height: 90px; position: fixed; background-color: white; width: 100%; border-bottom: solid thin #BDBDBD; ">
            <v-toolbar-items style="background-color: white; height: 45px; border-bottom: solid thin #BDBDBD; overflow-x: auto; ">
                <v-menu offset-y open-on-hover v-for="grp in menu_grp" v-bind:key="grp.menu_group_id" rounded="0">
                    <template v-slot:activator="{on}">
                        <v-btn class="font-weight-bold" v-on="on" text color="grey darken-3">
                            {{grp.menu_group_nm}}
                            <v-icon>mdi-menu-down</v-icon>
                        </v-btn>
                    </template>
                    <v-list :style="{maxHeight:fullHeight}">
                        <template v-for="(item, index) in grp.menu">
                            <v-list-item  :key="item.page" v-on:click="changePage(item.page)" style="background-color:white">
                                <v-list-item-content>
                                    <v-list-item-title>{{item.title}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider v-if="index < grp.menu.length - 1"
                                       :key="index"></v-divider>
                        </template>
                    </v-list>
                </v-menu>
               
            </v-toolbar-items>
            <h1 class="headline" style="margin-top:5px">
                <span class="font-weight-bold" style="font-size:20px;margin-left:70px;">{{title}}</span>
            </h1>
        </header>
    </div>

</template>
<script>export default {
        props: {
            title: { type: String, default: 'タイトル' },
            master: { type: Object, default: null }
        },
        data: () => ({
            menu_grp: [],
            fullHeight: window.innerHeight * 0.8 + 'px',
        }),
        mounted: function () {
            window.addEventListener('resize', this.handleResize);
 
        },
        beforeDestroy: function () {
            window.removeEventListener('resize', this.handleResize);
        },
        computed: {
            progressValue() {
                return Math.ceil(this.master.loaded_cnt / this.master.master_cnt * 100);
            }
        },
        methods: {
            handleResize: function () {
                this.fullHeight = window.innerHeight * 0.8 + 'px';
            },
            changePage(page) {

                this.isVisible = true;

                if (this.url === page) {

                    console.log('遷移しない');
                    return;

                }
                window.location.href = `/${page}`;

            },

            async onSearchMenuSelect() {

                try {
                    this.menu_grp = [];

                    var ctrl_nm = '';
                    var key = {};

                    //メニュー
                    ctrl_nm = '/CommonComponents/GetMenu';
                    key = { user_cd: this.app_user_cd};

                    const menus = await this.getData(ctrl_nm, key);
                    if (menus == null) {
                        return;
                    }

                    var top_group = { menu_group_id: -1, menu_group_nm:'TOP', menu: [] };
                    var top = { page: 'top', title: 'TOP', icon: 'mdi-vuetify' };
                    top_group.menu.push(top);
                    this.menu_grp.push(top_group);

                    var grp_id = [];
                    menus.forEach((g) => {

                        //メニューにデータ格納
                        var grp_item = { menu_group_id: g.menu_group_id, menu_group_nm: g.menu_group_nm, menu: [] };

                        if (!grp_id.includes(g.menu_group_id)) {

                            grp_id.push(g.menu_group_id);

                            menus.forEach((m) => {

                                if (m.menu_group_id == g.menu_group_id) {

                                    var menu_item = { page: m.page, title: m.title, icon: 'mdi-vuetify' };
                                    grp_item.menu.push(menu_item);

                                }

                            });

                            this.menu_grp.push(grp_item);

                        }

                    });


                } catch (e) {

                    this.msg_error_dialog(e);

                }

            },

            //データ取得非同期処理
            async getData(ctrl_nm, key) {

                var param = new URLSearchParams();

                param.append('param', JSON.stringify(key));

                let res = await this.axios_post(`${ctrl_nm}`, param);

                if (res.data.status !== "OK") {

                    this.msg_error_dialog(res.data.messages);
                    return null;

                }

                return res.data.data_list;

            }
        }
    };</script>
